import React, { useState, useRef, useEffect } from 'react';
import { bool, func, object } from 'prop-types';
import { noop } from 'lodash';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { s_play_circle } from '@fiverr-private/icons';
import Image from '../../Image';

const VideoSlide = ({
    slide = {},
    isActive = false,
    expanded = false,
    preload = false,
    onClick = noop,
    reportAction = noop,
}) => {
    const [showPlayer, setShowPlayer] = useState(false);
    const videoNode = useRef();

    useEffect(() => {
        if (showPlayer && videoNode.current) {
            isActive ? videoNode.current.play() : videoNode.current.pause();
        }
    }, [showPlayer, isActive]);

    const showVideo = (e) => {
        e && e.preventDefault();
        setShowPlayer(true);
    };

    const onClickWrapper = (e) => {
        if (showPlayer && videoNode.current) {
            videoNode.current.paused ? videoNode.current.play() : videoNode.current.pause();
        }

        onClick(e);
    };

    const handlePlay = () => {
        reportAction({
            isPlaying: true,
        });
    };

    const handlePause = () => {
        reportAction({
            isPlaying: false,
        });
    };

    const { src, media, name } = slide;
    const poster = expanded ? media.original : media.medium;
    const lazyLoadThumbnail = !isActive && !preload;

    return (
        <div className={classNames('slide', 'slide-video')} onClick={onClickWrapper}>
            <figure className="thumbnail">
                <Icon size={80} className="slide-play-button" onClick={showVideo}>
                    {s_play_circle}
                </Icon>
                <Image lazyLoad={lazyLoadThumbnail} isActive={isActive} alt={name} src={poster} />
            </figure>

            {showPlayer && (
                <video
                    src={src}
                    poster={poster}
                    controls={true}
                    ref={videoNode}
                    controlsList="nodownload"
                    onPlay={handlePlay}
                    onPause={handlePause}
                />
            )}
        </div>
    );
};

VideoSlide.propTypes = {
    slide: object.isRequired,
    isActive: bool,
    expanded: bool,
    onClick: func,
    preload: bool,
    reportAction: func,
};

export default VideoSlide;
